import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogContentBase, DialogModule, DialogRef } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { CasiCloseOptions, FormModes } from '../../../common/constants.lib';
import { Role } from '../../../models/models.lib';
import { AutoFocusDirective } from '../../../directives/auto-focus.directive';
import { LoggerService } from '../../../shared/logger.service';

@Component({
  selector: 'casi-edit-role-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    RouterLink, RouterLinkActive,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    DateInputsModule,
    LayoutModule,
    AutoFocusDirective
  ],
  templateUrl: './edit-role-modal.component.html',
  styleUrl: './edit-role-modal.component.scss'
})
export class EditRoleModalComponent extends DialogContentBase implements OnInit {

  private _role: Role | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set role(val: Role) {
    this._role = val;
    this.form.patchValue(this._role);
  }
  get role(): Role | undefined {
    return this._role;
  };

  private _mode: FormModes = FormModes.NOTSET;
  @Input({ required: true }) set mode(val: FormModes) {
    this._mode = val;
  }
  get mode(): FormModes {
    return this._mode;
  };

  form: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
  ) {
    super(dialog);
    this.form = this.fb.group(
      {
        id: [null, []],
        name: [null, [Validators.required]],
        permission_cnt: [null, []]
      }
    );
  }

  //#region Form

  get f() {
    return this.form.controls;
  }
  get name() {
    return this.form.get('name');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.form.value);
    if (this.form.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }
}

